import React, { useState, useEffect } from "react"
import NetworkApi from "../../services/networks";
import NetworksTable from "../../tables/NetworksTable"
import DashboardHeader from '../../components/DashboardHeader';
import { PopupboxContainer } from 'react-popupbox';
import LetterFilter from "../../components/LetterFilter";
import Pagination from "../../components/Pagination"
import useAuthErrorHandler from '../../hooks/useAuthErrorHandler';

function NetworksPage(props) {
    const [networks, setNetworks] = useState([]);
    const networkApi = new NetworkApi(props.token);
    const [search, setSearch] = useState('');
    const [searchCity, setSearchCity] = useState('');
    const [searchStatus, setSearchStatus] = useState('Published');
    const [totalPages, setTotalPages] = useState(0);
    const [pageItemActive, setPageItemActive] = useState(1);
    const [activeLetter, setActiveLetter] = useState('all'); 
    const handleAuthError = useAuthErrorHandler(); 

    const fetch = async() => {
        try {
            if(search && searchCity ){
                let response = await networkApi.searchByCity(searchCity, searchStatus, pageItemActive)
                    let filteredData = response.networks.filter((network) => network.name.toLowerCase().includes(search.toLowerCase()))
                    setNetworks([...filteredData]);
                    setTotalPages(response.total_pages);
            }
            else if (searchCity ) {
                let response = await  networkApi.searchByCity(searchCity, searchStatus, pageItemActive)
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
            }
            else if (activeLetter && activeLetter !== 'all') {
                let response = await networkApi.filterByLetter(searchStatus, activeLetter, pageItemActive);
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
            }   
            else if (search) {
                let response = await networkApi.search(search, searchStatus, pageItemActive)
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
            }
            else{
                let response = await networkApi.all(searchStatus, pageItemActive)
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
                if(!search && !searchCity){
                    setActiveLetter('all');
                }
            }
        } catch (error) {
            console.error(error);
            if (!handleAuthError(error)) {
                setNetworks([]);
            }
        }
    }

    useEffect(()=>{
        fetch()
    },[search, searchCity, searchStatus, activeLetter, pageItemActive])

    const __handleSearch = (event) => {
        setSearch(event.target.value);
        setActiveLetter(''); 
    };

    const handleSearchByCity =(event)=>{
        let value = event.target.value;
        setSearchCity(value);
        setActiveLetter(''); 
    }

    const handleSearchByStatus =(event)=>{
        let value = event.target.value;
        setSearchStatus(value);
    }
  
    const handleLetterClick = (letter) => {
        setSearch('')
        setSearchCity('')
        setPageItemActive(1); 
        if(letter === 'all'){
            setActiveLetter('all'); 
        }else{
            setActiveLetter(letter); 
        }
      };

    const handleSelectPage=(pageNumber)=>{
        setPageItemActive(pageNumber);
    }
    
    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Network" link='/network/new' />
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Networks</h2>
                    <div>
                        <div className='dashboard-content-search mx-2'>
                            <select                                
                                value={searchStatus}                                
                                className='dashboard-content-input search-status-input'
                                onChange={e => handleSearchByStatus(e)} >                                
                                <option value="All">All</option>    
                                <option value="Published">Published</option>    
                                <option value="Unpublished">Unpublished</option>
                            </select>
                        </div>
                        <div className='dashboard-content-search'>
                            <input
                                type='text'
                                value={search}
                                placeholder='Search by name..'
                                className='dashboard-content-input'
                                onChange={e => __handleSearch(e)} />
                        </div>
                        <div className='dashboard-content-search search-city-input'>
                            <input
                                type='text'
                                value={searchCity}
                                placeholder='Search by city..'
                                className='dashboard-content-input'
                                onChange={e => handleSearchByCity(e)} />
                        </div>
                    </div>
                </div>
                <LetterFilter activeLetter={activeLetter} onLetterClick={handleLetterClick}/>
                <div className="networks-custom-popup">
                    <PopupboxContainer />
                </div>
                    {
                        networks.length > 0 ?
                            <NetworksTable networks={networks} {...props} refresh={fetch} />
                            :
                            <div className='dashboard-content-footer'>
                                <span className='empty-table'>No data</span>
                            </div>
                    }
                <Pagination totalPages={totalPages} pageItemActive={pageItemActive} handleSelectItem={handleSelectPage}/>
            </div>
        </div>
    )
}

export default NetworksPage
